var _path, _ellipse, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeniedAccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 127,
    viewBox: "0 0 180 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1071 0C25.8979 0 24.1071 1.79086 24.1071 4V88.4177L0 112.532H180L157.5 88.4177V4C157.5 1.79086 155.709 0 153.5 0H28.1071ZM152.679 24.114H30.5357V86.8102H152.679V24.114ZM30.5357 6.82264C30.5357 5.71807 31.4311 4.82264 32.5357 4.82264H150.679C151.783 4.82264 152.679 5.71808 152.679 6.82264V19.291H30.5357V6.82264ZM171.964 110.923L154.286 91.6319H27.3212L8.03551 110.923H171.964ZM0 112.532V123C0 125.209 1.79086 127 4 127H176C178.209 127 180 125.209 180 123V112.532H0ZM4.82146 115.746V120.176C4.82146 121.281 5.71689 122.176 6.82146 122.176H173.179C174.283 122.176 175.179 121.281 175.179 120.176V115.746H4.82146Z",
    fill: "#2777B8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.9999,
    cy: 11.2533,
    rx: 3.21429,
    ry: 3.21519,
    fill: "#2777B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 70.7339C92.6628 70.7339 94.8214 68.5747 94.8214 65.9112C94.8214 63.2476 92.6628 61.0884 90 61.0884C87.3372 61.0884 85.1786 63.2476 85.1786 65.9112C85.1786 68.5747 87.3372 70.7339 90 70.7339ZM89.9999 69.1262C91.7751 69.1262 93.2142 67.6867 93.2142 65.911C93.2142 64.1353 91.7751 62.6958 89.9999 62.6958C88.2247 62.6958 86.7856 64.1353 86.7856 65.911C86.7856 67.6867 88.2247 69.1262 89.9999 69.1262Z",
    fill: "#2777B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7144 49.8352C71.6098 49.8352 70.7144 50.7306 70.7144 51.8352V78.3795C70.7144 79.4841 71.6098 80.3795 72.7144 80.3795H107.286C108.39 80.3795 109.286 79.4841 109.286 78.3795V51.8352C109.286 50.7306 108.39 49.8352 107.286 49.8352H72.7144ZM74.9285 52.8887C74.3763 52.8887 73.9285 53.3364 73.9285 53.8887V76.3241C73.9285 76.8764 74.3763 77.3241 74.9285 77.3241H105.071C105.624 77.3241 106.071 76.8764 106.071 76.3241V53.8887C106.071 53.3364 105.624 52.8887 105.071 52.8887H74.9285Z",
    fill: "#2777B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9286 43.4003C73.9286 34.5243 81.124 27.3289 90 27.3289C98.876 27.3289 106.071 34.5243 106.071 43.4003V49.8352H102.857V43.5352C102.857 36.4344 97.1009 30.6781 90.0001 30.6781C82.8993 30.6781 77.1429 36.4344 77.1429 43.5352V49.8352H73.9286V43.4003ZM96.4286 49.8346V43.4031C96.4286 39.8527 93.5504 36.9745 90 36.9745C86.4496 36.9745 83.5714 39.8527 83.5714 43.4031V49.8346H80.3571V43.4015C80.3571 38.0759 84.6743 33.7586 89.9999 33.7586C95.3255 33.7586 99.6428 38.0759 99.6428 43.4015V49.8346H96.4286Z",
    fill: "#2777B8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5356,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5356,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#2777B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4286,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#2777B8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3214,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#2777B8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2144,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2144,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#2777B8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 114.107,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#2777B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 98.0635,
    width: 16.0714,
    height: 6.43038,
    rx: 3.21519,
    fill: "#2777B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeniedAccessIcon);
export default __webpack_public_path__ + "static/media/DeniedAccessIcon.a3c9c446d991e18aca44f15b06e17f30.svg";
export { ForwardRef as ReactComponent };